import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from 'mobx';
import { withRouter } from "react-router-dom";
import { ToolbarDropdown, ToolbarSection } from "@components/Toolbar/ToolbarDropdown"
import PurchaseOrderSettings from "./PurchaseOrderSettings";



@inject("store")
@observer
class PurchaseOrderAdd extends React.Component {
    @observable processingCheckout = false;


    constructor(props) {
        super(props);

    }


    render() {
        const { store } = this.props;
        const orderStore = store.order;

        const headerClasses = [
            "header",
            "checkout",
            this.headerExpanded ? "expanded" : null
        ];

        const footerClasses = [
            "footer",
            "checkout",
            this.footerExpanded ? "expanded" : null
        ];

        const parentMatch = this.props.match;


        if (this.props.store.navigation.CustomerRoleIsReadOnly) {
            return (
                <ToolbarDropdown key={"order"} match={parentMatch}>
                    <ToolbarSection>
                        <div className="mt-2">


                            <div className="card-body">
                                You don´t have access to create a new order
						</div>

                        </div>
                    </ToolbarSection>

                </ToolbarDropdown>
            );
        }

        return (


            <ToolbarDropdown key={"order"} match={parentMatch}
                {...this.props}
            >
                <ToolbarSection>
                    <div className="mt-2">


                        <div className="card-body">
                            <PurchaseOrderSettings />
                        </div>

                    </div>
                </ToolbarSection>

            </ToolbarDropdown>
        );
    }
}



export default withRouter(PurchaseOrderAdd);